<template>
  <FeatureDetailPage feature-key="communications" />
</template>
